import { GlobalSearchCategorySchema } from "@redotech/redo-model/global-search/global-search-category";
import { RedoDocumentationSchema } from "@redotech/redo-model/redo-documentation";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getRedoDocumentations = {
  name: "getRedoDocumentations" as const,
  input: z.object({
    category: GlobalSearchCategorySchema.optional(),
    enabled: z.boolean().optional(),
    searchText: z.string().optional(),
    sortKey: createEnum([
      "title",
      "priority",
      "createdAt",
      "updatedAt",
    ]).optional(),
    sortDirection: createEnum(SortDirection).optional(),
    limit: z.number().int().min(1).max(100).optional(),
    skip: z.number().int().min(0).optional(),
  }),
  output: z.object({
    results: z.array(RedoDocumentationSchema),
    total: z.number().int(),
  }),
};
